<template>
  <div v-if="(adminRequired && isAdmin()) || !adminRequired">
      <!-- <pre>{{$firebase.auth().currentUser.email}}</pre> -->
    <div class="card page-card" v-if="page.url && !processed">
        <!-- <pre>{{page}}</pre> -->
        <!-- <pre>{{isAdmin()}}</pre> -->
            <div class="columns page-card-columns">

                <!-- <a class="image-placeholder column image-column is-one-third" v-bind:href="page.url" target="_blank" ></a>     -->
                <a v-if="page.image && page.image != '' && !page.image_placeholder" v-bind:href="page.url" target="_blank" class="column image-column is-one-third" :style="{ backgroundImage: `url(${page.image})`}"></a>
                <a v-if="!page.image || page.image == '' || page.image_placeholder" v-bind:href="page.url" target="_blank" class="column image-column is-one-third" :style="{ backgroundImage: `url(https://bikesleepbike.com/bsb_placeholder_dark.jpg)` }"></a>
                <div class="column text-column">
                    <!-- <div class="title is-5 margin-bottom">
                        <a v-bind:href="page.url" target="_blank" class="is-success">{{page.title}}</a>
                    </div> -->

                    <div class="title is-5 margin-bottom">
                        <a v-bind:href="page.url" target="_blank" class="is-success">{{page.title ? page.title : page.url}}</a>
                    </div>

                    <!-- <div v-if="approveMode && isAdmin() &&  !page.is_edit"> -->
                    <div v-if="approveMode && isAdmin()">
                        <b-field>
                            <b-input  placeholder="title" type="text" v-model="adminTitle" size="is-medium"></b-input>
                        </b-field>
                        <b-field>
                            <b-input  placeholder="image url" type="text" v-model="adminImage" size="is-medium"></b-input>
                        </b-field>

                    </div>
                    <!-- <div v-if="approveMode && isAdmin() &&  !page.is_edit">
                        <b-field>
                            <b-input  placeholder="post url" type="text" v-model="adminUrl" size="is-medium"></b-input>
                        </b-field>

                    </div> -->
                    <!-- <div v-if="!page.is_edit">
                        <b-field>
                            <b-input  placeholder="image url" type="text" v-model="adminImage" size="is-medium"></b-input>
                        </b-field>

                    </div> -->

                    <div v-if="approveMode && isAdmin() && page.email">{{page.email}}</div>
                    <div v-if="approveMode && isAdmin() && page.added">{{page.added.toDate()}}</div>

                    <div class="margin-bottom">
                        <a target="_blank" v-bind:href="page.url.split('://')[0] + '://' + page.url.split('://')[1].split('/')[0]" >{{page.site_name ? page.site_name : page.url.split('://')[1].split('/')[0]}}</a>
                        <span v-if="(showYear && page.year && page.year != '') || approveMode"> - {{page.year}}</span>
                    </div>
                    <div>
                        <span v-if="page.countries && page.countries.length > 0">
                            <b-tag
                                class="tag" 
                                
                                type="is-primary"
                                v-for="code in page.countries.concat().sort()"
                                v-bind:key = code
                               
                                > 
                                <span style="cursor:pointer" @click="changeCountry(code)">{{$countrymap[code]}}</span>
                            </b-tag>
                        </span>
                    <!-- this.$getParent('FindTrip').setCountryInput(code) -->

                        <span v-if="page.regions && page.regions.length > 0">
                            <b-tag
                                class="tag is-primary" 
                                v-for="region in page.regions.concat().sort()"
                                v-bind:key = region
                                
                                >
                                <span style="cursor:pointer" @click="changeSubregion(region)">{{region}}</span>
                            </b-tag>
                        </span>

                        <span v-if="page.routes && page.routes.length > 0">
                            <b-tag
                                class="tag is-info" 
                                
                                v-for="route in page.routes.concat().sort()"
                                v-bind:key = route
                                >
                                <span style="cursor:pointer" @click="changeRoute(route)">{{route}}</span>
                            </b-tag>
                        </span>
                    </div>
                    
                    <div>
                        <span v-if="(page.touring || page.bikepacking)">
                            <b-tag v-if="page.touring" class="tag is-light" >touring</b-tag>
                            <b-tag v-if="page.bikepacking" class="tag is-light" >bikepacking</b-tag>
                        </span>

                        

                        <span v-if="page.surfaces && page.surfaces.length > 0">
                            <b-tag
                                class="tag is-light" 
                                v-for="surface in page.surfaces.concat().sort()"
                                v-bind:key = surface
                                >
                                {{surface}}
                            </b-tag>
                        </span>

                        <span v-if="(page.features && page.features.length > 0)">
                            <b-tag
                                class="tag is-light" 
                                v-for="feature in page.features.concat().sort()"
                                v-bind:key = feature
                                >
                                {{feature}}
                            </b-tag>
                        </span>
                        

                    </div>

                    <div v-if="page.ridertags && page.ridertags.length > 0">
                        <b-tag
                            class="tag is-light" 
                            v-for="ridertag in page.ridertags.concat().sort()"
                            v-bind:key = ridertag
                            >
                            {{ridertag}}
                        </b-tag>
                    </div>

                    <div v-if="page.short || page.video || page.podcast || page.map" style="">
                        <b-tag v-if="page.short" class="tag is-lightgray">short trip</b-tag>
                        <b-tag v-if="page.map" class="tag is-lightgray">map</b-tag>
                        <b-tag v-if="page.video" class="tag is-lightgray">video</b-tag>
                        <b-tag v-if="page.podcast" class="tag is-lightgray">podcast</b-tag>
                    </div>


                </div>
                <span v-if="page.content_type == 'video'" class="content-type-icon" style="position:absolute; top:10px; left:10px; background-color:#2763a1; text-align:center;  border-radius:5px; width:25px; height:25px">

                    <b-icon style="margin-left:auto; margin-right:auto"
                        icon="play-circle"
                        size="is-small"
                        type="is-light">
                    </b-icon>
                </span>
                <!-- <pre>{{page.approved_on.toDate()}}</pre> -->
                <b-collapse :open="false" aria-id="contentIdForA11y1" v-if="page.previous && approveMode && isAdmin()">
                                <a
                                    class="button is-primary"
                                    slot="trigger"
                                    aria-controls="contentIdForA11y1">Show Previous</a>
                                <div class="">
                                    <div class="">
                                        <pre>{{page.previous}}</pre>
                                    </div>
                                </div>
                            </b-collapse>


            </div>
            <div v-if="approveMode && isAdmin()" class="">
                <b-input v-if="!page.year" v-model="adminYear" placeholder='year' />
                <b-input v-if="!page.routes || page.routes.length == 0" v-model="adminRoutes" placeholder='routes' />
                <b-input v-if="!page.ridertags || page.ridertags.length == 0" v-model="adminRidertags" placeholder='ridertags' />
                <b-input v-model="adminPriority" placeholder='priority (-1, 0, 1)' />
            </div>
            <div v-if="approveMode && isAdmin()" class="admin-buttons">
                <b-button v-if="approveMode && isAdmin()" type="is-danger"  @click="approvePage(page)">APPROVE</b-button>
                <b-button v-if="approveMode && isAdmin()" type="is-warning" @click="rejectPage(page)">REJECT</b-button>
            </div>
            <div v-if="!approveMode && isAdmin()" class="admin-buttons">
                <b-button v-if="!approveMode && isAdmin()"  type="is-danger" @click="deletePage(page)">DELETE</b-button>
            </div>
            <!-- <b-button type="is-warning" @click="editPage(page)">EDIT</b-button> -->
        </div>  
        
    </div>


</template>

<script>
// import CustomTagInput from '@/components/CustomTagInput';

export default {
  name: 'PageResult',
  props: ["page", "showYear", "approveMode", "adminRequired"],
  data () {
    return {
        // admin mode
        processed: false,
        adminTitle: "",
        adminImage: "",
        adminYear: "",
        adminRoutes: "",
        adminRidertags: "",
        adminPriority: ""
        // adminUrl: ""
    }
  },
  methods: {
        changeCountry(code) {
            // console.log(code);
            this.$getParent('FindTrip').setCountryInput(this.$countrymap[code]);
        },
        changeRoute(route) {
            // console.log(route);
            this.$getParent('FindTrip').setRouteInput(route);
        },
        changeSubregion(region) {
            // console.log(route);
            this.$getParent('FindTrip').setSubregionInput(region);
        },
        approvePage(page) {
            if (this.adminTitle != "") {
                // toUpdate.title = this.adminTitle;
                page.title = this.adminTitle.trim();
            }
            // if (this.adminImage != "") {
                page.image = this.adminImage.trim();
            // }
            // if (this.adminUrl != "") {
            //     page.url = this.adminUrl.trim();
            // }
            if (this.adminYear != "") {
                page.year = this.adminYear.trim();
            }
            if (this.adminPriority != "") {
                page.priority = parseInt(this.adminPriority.trim());
            }
            if (this.adminRoutes != "") {
                
                if (!page.routes) { page.routes = []; }
                var routesArray = this.adminRoutes.trim().split(",");
                for (var idx in routesArray) {
                    
                    page.routes.push(routesArray[idx].trim());
                }
                // page.routes = this.adminRoutes.trim().split(",");
            }
            if (this.adminRidertags != "") {
                if (!page.ridertags) { page.ridertags = []; }
                var ridertagsArray = this.adminRidertags.trim().split(",");
                for (var idx in ridertagsArray) {
                    // console.log(idx, " - ", ridertagsArray[idx]);
                    page.ridertags.push(ridertagsArray[idx].trim());
                }
                
                // page.ridertags = this.adminRidertags.trim().split(",");
            }
            // if (page.previous) {
            //     delete page.previous;
            // }
            // this.$writeDoc("pages", page.id, toUpdate, true );
            var that = this;
            var emailAddress = page.email;
            // var submittedOn = page.added;
            // if (!submittedOn) {submittedOn = "";}
            // var editApprovedOn = newDate();
            var approvedOn = new Date();
            if (emailAddress) {
                delete page.email;
            }
            page['approved_on'] = approvedOn;

            // console.log("Cleaned page");
            // console.log(page);
            this.$db.collection("pages").doc(page.id).set(page, { merge: true })
                .then(function() {
                    if (emailAddress) {

                        var emailDoc = { address: emailAddress, approved_on: approvedOn, sent: false, post_url:page.url, site_url: page.url.split('://')[1].split('/')[0] };
                        var submittedOn = page.added;
                        if (!submittedOn) {
                            submittedOn = page.last_edited_on;
                        }
                        if (submittedOn) {
                            emailDoc.submitted_on = submittedOn;
                        }
                        if (page.is_edit) {
                            emailDoc.edit = true;
                        }
                        that.$db.collection("emails").doc(page.id).set( emailDoc, { merge: true });
                        // if (page.is_edit) {
                        //     // console.log({address: emailAddress, submitted_on: submittedOn, approved_on: approvedOn, edit: true, sent: false, post_url:page.url, site_url: page.url.split('://')[1].split('/')[0]});
                        //     that.$db.collection("emails").doc(page.id).set( emailDoc, { merge: true });
                        // } else {
                        //     that.$db.collection("emails").doc(page.id).set({address: emailAddress, submitted_on: submittedOn, approved_on: approvedOn, sent: false, post_url:page.url, site_url: page.url.split('://')[1].split('/')[0]}, { merge: true });
                        // }
                    }

                    
                    that.$db.collection("pages").doc(page.id).set(page, { merge: true }).then(function() { //after page is updated, delete previous field so we don't get too many nested previous's
                        that.$db.collection("pages").doc(page.id).update({
                            previous: that.$firebase.firestore.FieldValue.delete()
                        });
                    });
                    that.$db.collection("pages_unapproved").doc(page.id).delete();
                    that.processed = true;
                    // that.loadNewPages();
                })
                .catch(function(error) {
                    console.error("Error approving document: ", error);
                });

            // this.loadNewPages();
        },
        rejectPage(page) {
            var that = this;
            this.$db.collection("pages_unapproved").doc(page.id).delete()
                .then(function() {
                    that.processed = true;
                }).catch(function(error) {
                    console.error("Error removing document: ", error);
                });
            
        },
        deletePage(page) {
            var that = this;
            console.log(page.id);
            this.$db.collection("pages").doc(page.id).delete()
                .then(function() {
                // console.log(fields);
                    console.log("Document deleted!");
                    // console.log(fields);
                    // that.loadNewPages();
                    // that.processed = true;
                }).catch(function(error) {
                    console.error("Error removing document: ", error);
                });
            
        },
        isAdmin() {
            return (this.$firebase.auth().currentUser.email == 'alissa.w.bell@gmail.com');
        }
  },
    mounted() {
        if (this.page.title && this.page.title != "") {
            this.adminTitle = this.page.title;
        }
        if (this.page.image && this.page.image != "") {
            this.adminImage = this.page.image;
        }
        // if (this.page.url && this.page.url != "") {
        //     this.adminUrl = this.page.url;
        // }
    }
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.page-card {
        padding:0;
        margin:0;
        margin-bottom: 30px;
    }
    .page-card .image-column {
        padding:0;
        margin:0;
    }
    .page-card .text-column {
        padding:20px 30px;
        text-align: left;
    }
    @media screen and (max-width: 789px) { 
        .page-card .text-column {
            padding:20px;
        }
    }
    .page-card-columns {
        margin:0;
    }

      .admin-btn {
      position:absolute;
      top:0;
      right:0;
  }
   .image-placeholder {
      position: absolute;
      background-image: url(https://bikesleepbike.com/bsb_placeholder.jpg);
      width:200px;
      height:100%;
      z-index: -1;
  } 
   .image-column {
        background-size: cover;
        background-position: 50%;
        min-height:200px;
    }
    .margin-bottom {
        margin-bottom:10px;
    }
    .tag {
        margin-right:3px;
        margin-bottom:3px;
    }
    .admin-buttons {
        position: absolute;
        bottom: 0;
        right: 0;
    }
    .tag.is-lightgray {
        background-color:#f3f2f2;
    }

</style>





// WEBPACK FOOTER //
// src/components/PageResult.vue